<template>

	<v-overlay
		:model-value="isActive"
		scroll-strategy="block"
		transition="hide-leave"
		:scrim="false"
		persistent
		class="app-preview-sidebar-overlay"
		@update:modelValue="emit('updateActiveState', false)"
	>
		<template #default>

			<div
				class="app-preview-sidebar"
				:class="{'active': isActive}"
			>
				<ao-icon-btn
					iconName="close"
					variant="text"
					class="close-action"
					@click="emit('updateActiveState', false)"
				/>
				<div class="sidebar-content">
					<slot name="preview-master-content"/>
				</div>
			</div>

		</template>
	</v-overlay>

</template>

<script setup>
/* const props =  */defineProps({
	isActive: Boolean,
})
const emit = defineEmits({
	'updateActiveState': null,
})
</script>

<style lang="scss">
.app-preview-sidebar-overlay {

	.v-overlay__content {
		position: fixed;
		top: 0;
		left: 300px;
		bottom: 0;
		width: 26rem;
		max-width: 90vw;
	}

}

.app-preview-sidebar {
	width: 100%;
	height: 100%;
	background-color: white;

	.close-action {
		position: absolute;
		z-index: 1;
		top: 0.75rem;
		right: 0.75rem;
	}

	.sidebar-content {
		height: 100%;
		overflow: auto;
    overflow-x: hidden;
	}
}
</style>
